import * as moment from 'moment'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { TRIPS_HISTORY_COLUMNS } from '../../state/constants/index'
import { ITripHistoryObject } from '../../types/index'

interface ITripsHistoryListItemProps {
  trip: ITripHistoryObject
  columns: TRIPS_HISTORY_COLUMNS[]
}

class TripsHistoryListItem extends React.Component<any> {
  public render() {
    const { trip } = this.props
    return (
      <Link to={`/trips-history/${trip.id}`}>
        <div className='flex justify-between pl3'>
          <div className='flex col-12'>
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.DATE) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{moment(trip.createdAt).format('DD.MM.YYYY')}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.PICKUP_TIME) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{trip.pickUpTime ? moment(trip.pickUpTime).format('HH:mm a') : ''}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.ARRIVAL_TIME) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>
                  {trip.dropOffTime ? moment(trip.dropOffTime).format('HH:mm a') : ''}
                </p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.STATUS) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{trip.status.status}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.RIDER_NAME) && (
              <div className='col-6'>
                <p className='h5 font-dark-grey'>{(trip.rider.firstName + ' ' + trip.rider.lastName).trim()}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.PROVIDER) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{trip.provider}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.SERVICE) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{trip.service.name}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.COST) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{`$ ${trip.cost}`}</p>
              </div>
            )}
            {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.FARE) && (
              <div className='col-3'>
                <p className='h5 font-dark-grey'>{`$ ${trip.fare}`}</p>
              </div>
            )}
          </div>
        </div>
      </Link>
    )
  }
}

export default TripsHistoryListItem



// WEBPACK FOOTER //
// ./src/components/trips/TripsHistoryListItem.tsx